import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tools from "./JNSTools";
import IconButton from "@mui/material/IconButton";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CredsContext } from "./Contexts";
import * as Ably from "ably";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useConnectionStateListener,
} from "ably/react";
import "./styles/ChatComponent.css";

function ChatComponentDropdown() {
  const creds = useContext(CredsContext).creds;
  const [expanded, setExpanded] = useState(false);
  const [fontsize, setFontsize] = useState(12);
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const EXPANDED_WIDTH = 700;
  //const CONTRACTED_WIDTH = 332;
  const CONTRACTED_WIDTH = 400;
  const MINIMUM_FONT_SIZE = 10;
  const MAXIMUM_FONT_SIZE = 24;
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef();
  const { channel } = useChannel(creds.company, projectObject.name, (mObj) => {
    const dbObj = {
      messageId: mObj.id,
      companyProject: mObj.data.companyProject,
      data: mObj.data.messageText,
      timestamp: mObj.timestamp,
      timestampString: new Date(mObj.timestamp).toLocaleString(),
      user: mObj.data.user,
    };
    if (mObj.data.user == creds.name) {
      Tools.dbWrite("collabCenterChats", dbObj);
    }
    setMessages((previousMessages) => [...previousMessages, dbObj]);
  });

  let textAreaInstance;

  useEffect(() => {
    const expressionValue =
      creds.company + "|" + projectObject.customerid + "|" + projectObject.id;
    const expression = "companyProject = :cpValue";
    const values = { ":cpValue": expressionValue };

    Tools.dbQuery(
      "collabCenterChats",
      "companyProject-index",
      expression,
      values,
    ).then((dbRecords) => {
      dbRecords.sort((a, b) => a.timestamp - b.timestamp);
      setMessages(dbRecords);
    });
  }, []);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const handleZoomIn = () => {
    if (fontsize < MAXIMUM_FONT_SIZE) {
      setFontsize(fontsize + 2);
    }
  };

  const handleZoomOut = () => {
    if (fontsize > MINIMUM_FONT_SIZE) {
      setFontsize(fontsize - 2);
    }
  };

  const handleDownload = () => {
    if (messages.length > 0) {
      let downloadableAnswer = "";

      messages.forEach((answerLine) => {
        downloadableAnswer +=
          answerLine.user.toUpperCase() +
          String.fromCharCode(13) +
          String.fromCharCode(10) +
          answerLine.data +
          String.fromCharCode(13) +
          String.fromCharCode(10);
      });

      let dataUrl = "data:text/plain," + downloadableAnswer;
      let a = document.createElement("a");
      a.href = dataUrl;
      a.download =
        "collabcenter_AIexport_" +
        new Date().toISOString().substring(0, 19) +
        ".txt";
      a.click();
    }
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      const msgObj = {
        user: creds.name,
        messageText: event.target.value,
        companyProject:
          creds.company +
          "|" +
          projectObject.customerid +
          "|" +
          projectObject.id,
      };

      textAreaInstance.value = "";
      // first value is the "message name"
      channel.publish(projectObject.name, msgObj);
    }
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behaviour: "smooth" });
    }
  });

  return (
    <Box
      width={expanded ? EXPANDED_WIDTH : CONTRACTED_WIDTH}
      sx={{
        height: "600px",
        border: "solid 1px",
        backgroundColor: "dimgray",
        borderRadius: "10px",
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box>
          <IconButton onClick={handleExpand} sx={{ padding: "0px 20px" }}>
            {expanded ? (
              <EastIcon fontSize="medium" sx={{ color: "white" }} />
            ) : (
              <WestIcon fontSize="medium" sx={{ color: "white" }} />
            )}
          </IconButton>
        </Box>
        <Box>
          <IconButton onClick={handleZoomIn} sx={{ padding: "0px" }}>
            <ZoomInIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
          <IconButton onClick={handleZoomOut} sx={{ padding: "0px" }}>
            <ZoomOutIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
        </Box>
        <Box>
          <IconButton onClick={handleDownload} sx={{ padding: "0px 20px" }}>
            <FileDownloadIcon fontSize="medium" sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </Box>
      <Box
        width={expanded ? EXPANDED_WIDTH - 30 : CONTRACTED_WIDTH - 30}
        sx={{
          margin: "0px 15px 10px 15px",
          height: "560px",
          border: "solid 2px",
          borderColor: "white",
          borderRadius: "10px",
          backgroundColor: "black",
          overflowY: "auto",
        }}
      >
        <Stack>
          <Box
            className="mainChatBox"
            sx={{ height: "470px", overflowY: "auto" }}
          >
            {messages.map((messageObject, index) => {
              return (
                <Box
                  key={messageObject.messageId}
                  className="individualChatMessageBox"
                  ref={index == messages.length - 1 ? scrollRef : null}
                >
                  <span
                    style={{
                      color: "firebrick",
                      fontWeight: "bold",
                      fontSize: fontsize + "px",
                    }}
                  >
                    {messageObject.user}&nbsp;
                  </span>
                  <span
                    style={{
                      color: "gray",
                      fontSize: fontsize - 4 + "px",
                      fontStyle: "italic",
                    }}
                  >
                    {messageObject.timestampString}
                  </span>
                  <br></br>
                  <span style={{ color: "black", fontSize: fontsize + "px" }}>
                    {messageObject.data}
                  </span>
                </Box>
              );
            })}
          </Box>
          <Box width={expanded ? EXPANDED_WIDTH - 35 : CONTRACTED_WIDTH - 40}>
            <textarea
              ref={(messageArea) => (textAreaInstance = messageArea)}
              type="text"
              id="chatText"
              onKeyUp={handleKeyPress}
              rows={4}
              placeholder="Type your message here..."
              style={{
                width: expanded ? EXPANDED_WIDTH - 48 : CONTRACTED_WIDTH - 48,
                resize: "none",
                display: "inline-block",
                verticalAlign: "middle",
                fontFamily: "sans-serif",
                fontSize: "medium",
                margin: "5px",
                //cursor: helpMode ? "help" : "text",
                cursor: "text",
              }}
            ></textarea>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}

export default ChatComponentDropdown;

/*          threadId={"defaultThreadProject" + projectObject.id}
          groupId={creds.company}
          //location={{ page: "index" }}
          //onRender={threadRendered}
          //metadata={{ foo: "bar" }}
          style={{
            height: "478px",
            maxHeight: "700px", // Recommended so that long threads scroll instead of disappearing off-screen
            width: expanded ? EXPANDED_WIDTH - 32 : CONTRACTED_WIDTH - 32, // Recommended so that threads don't stretch horizontally based on their content
            fontSize: fontsize,
          }}
        />*/
